// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"126":"930481154caa8663","581":"f1ae9f20c94ace7b"}[chunkId] + ".js";
};